import Api from "../axios";

export const addPolicy = (policyData) => {
  return Api.post("add_policy", policyData);
};
